<template>
    <Link class="btn btn-orange-custom text-white">{{ $t('button.create') }}</Link>
</template>

<script setup lang="ts">
import {Link} from "@inertiajs/vue3";
</script>

<style scoped>

</style>
